import Http from './../http';

const prefix = '/footer-website';

export const create = params => Http.authApi().post(`${prefix}`, params);

export const update = header => {
  return Http.authApi().put(`${prefix}/${header.encrypted_id}`, header);
};

export const destroy = header => {
  return Http.authApi().delete(`${prefix}/${header.encrypted_id}`, header);
};

export const get = id => {
  return Http.authApi().get(`${prefix}/${id}`);
};

export const duplicate = item => {
  return Http.authApi().post(`/duplicate${prefix}/${item.encrypted_id}`);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/footers.js